<template>
  <div>
    <LeftSidebar
      :visible="visible"
      baseClass="parvandeh-status-wrapper"
      :title="title"
      @close="close"
    >
      <template>
        <ParvandehReportsList
          :visible="visible"
          :code="code"
          :saltFileName="saltFileName"
        />
      </template>
    </LeftSidebar>
  </div>
</template>

<script>
import { LeftSidebar } from "@/components/re-design";
import ParvandehReportsList from "./ParvandehReportsList.vue";

export default {
  components: { LeftSidebar, ParvandehReportsList },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    code: {
      type: [String, Number],
      default: null,
    },
    saltFileName: {
      type: [String, Number],
      default: null,
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>
